document.addEventListener('DOMContentLoaded', () => {
  const toggleMyReservationsCalendarButton = document.getElementById('toggle-my-reservations-calendar');
  const toggleMyReservationsTableButton = document.getElementById('toggle-my-reservations-table');
  const myReservationsCalendar = document.getElementById('my-reservations-calendar');
  const myReservationsTable = document.getElementById('my-reservations-table');

  const toggleButtons = () => {
    toggleMyReservationsCalendarButton.classList.toggle('hide-view');
    toggleMyReservationsTableButton.classList.toggle('hide-view');
  };

  const toggleViews = () => {
    myReservationsCalendar.classList.toggle('hide-view');
    myReservationsTable.classList.toggle('hide-view');
  };

  if (toggleMyReservationsCalendarButton) {
    toggleMyReservationsCalendarButton.addEventListener('click', () => {
      toggleViews();
      toggleButtons();
    });
  }

  if (toggleMyReservationsTableButton) {
    toggleMyReservationsTableButton.addEventListener('click', () => {
      toggleViews();
      toggleButtons();
    });
  }
});
